import React, { useEffect, useRef, useState } from 'react'
import styles from './IconTextCard.module.sass'
import { getIcon } from '@next-nx/utils/icons'
import { MenuItemType } from '@next-nx/utils/types'
import { ChevronDown, ChevronUp } from '@next-nx/shared-ui/icons'
import { Button } from '@next-nx/shared-ui/atoms'
import { useTrans } from '@next-nx/hooks'

interface Props {
  className?: string
  item?: MenuItemType
}

const IconTextCard = (props: Props) => {
  const { className = '', item = undefined } = props

  const t = useTrans()
  const descriptionRef = useRef(null)
  const [readMoreOpen, setReadMoreOpen] = useState(false)
  const [showReadMore, setShowReadMore] = useState(false)

  useEffect(() => {
    const lineHeight = 24
    const maxLines = 6
    if (descriptionRef?.current?.clientHeight) {
      setShowReadMore(descriptionRef?.current?.clientHeight > lineHeight * maxLines)
    }
  }, [descriptionRef?.current?.clientHeight])

  return (
    <div className={`${styles.root} ${className}`}>
      <div>
      {!!getIcon(item?.style) && <div className={styles.icon}>{getIcon(item?.style)}</div>}
      {!!item?.name && <div className={styles.name}>{item?.name}</div>}
      <div className={styles.layout}>
        <div
          className={`${styles.descriptionBox} ${
            showReadMore ? styles['descriptionBox--overflow'] : ''
          }`}
          style={{
            height: showReadMore
              ? descriptionRef?.current && readMoreOpen
                ? descriptionRef.current.clientHeight
                : 0
              : undefined,
          }}
        >
          {!!item.description &&
            (typeof item.description !== 'string' ? (
              <div className={styles.description} ref={descriptionRef}>
                {item.description}
              </div>
            ) : (
              <div
                className={styles.description}
                dangerouslySetInnerHTML={{ __html: item.description }}
                ref={descriptionRef}
              />
            ))}
        </div>
        {showReadMore && (
          <div className={styles.readMoreBox}>
            <Button
              label={t(readMoreOpen ? 'Chiudi' : 'Leggi di più')}
              icon={readMoreOpen ? <ChevronUp /> : <ChevronDown />}
              iconPos="right"
              variant="ghost"
              color="blue"
              onClick={() => setReadMoreOpen(!readMoreOpen)}
            />
          </div>
        )}
      </div>
      </div>
    </div>
  )
}

export default IconTextCard
